import { Maybe } from '../../../../../types';
import { AddressFormValues } from '../types';

const REQUIRED_FIELDS: Array<keyof AddressFormValues> = [
  'address_line_1',
  'city',
  'state_province_region',
  'zip_postal_code',
];

const isFilled = (value: unknown): boolean => {
  return String(value ?? '').trim() !== '';
};

/**
 * True when the address carried by the state token is complete enough to be
 * confirmed as-is. `street_number` and `address_line_2` are optional on the
 * carrier API, so they never gate the check.
 */
export const isEmergencyAddressComplete = (
  address: Maybe<Partial<AddressFormValues>> | undefined,
): boolean => {
  if (!address) {
    return false;
  }

  return REQUIRED_FIELDS.every(field => {
    return isFilled(address[field]);
  });
};
